// menu
export const FEATURES = "FEATURES";
export const FILE = "FILE";
export const NEW_TASK = "NEW_TASK";
export const TASKS = "TASKS";

export const GEOMETRY_TYPES = {
    POINT: "Point",
};